/**
 * @voltxampere/spice — Codec param helpers
 *
 * Shared utilities every element codec needs: pulling a numeric
 * (or string-as-numeric) param off a `ComponentInstance.params`
 * record, with a sensible fallback when the value is missing or
 * malformed.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { parseSpiceNumber } from "../units.js";
export function numericParam(raw, fallback) {
    if (typeof raw === "number" && Number.isFinite(raw))
        return raw;
    if (typeof raw === "object" && raw !== null && "value" in raw) {
        const value = raw.value;
        if (typeof value === "number" && Number.isFinite(value))
            return value;
    }
    if (typeof raw === "string") {
        const parsed = parseSpiceNumber(raw);
        if (parsed !== null)
            return parsed;
    }
    return fallback;
}
export function stringParam(raw, fallback) {
    if (typeof raw === "string")
        return raw;
    if (typeof raw === "object" && raw !== null && "value" in raw) {
        const value = raw.value;
        if (typeof value === "string")
            return value;
    }
    return fallback;
}
/**
 * Strip surrounding parens from a function-call body produced by
 * the lexer. `PULSE(0 5 1m 1u 1u 5m 10m)` → `0 5 1m 1u 1u 5m 10m`.
 * Returns null if the input is not parens-wrapped.
 */
export function stripFunctionBody(token) {
    const match = /^\w+\((.*)\)$/.exec(token);
    if (match === null)
        return null;
    return (match[1] ?? "").trim();
}
export function functionName(token) {
    const match = /^(\w+)\(/.exec(token);
    if (match === null)
        return null;
    return (match[1] ?? "").toUpperCase();
}
//# sourceMappingURL=_param-helpers.js.map